export const PropertyTypology = {
    APARTMENT: 'apartment',
    PENTHOUSE: 'penthouse',
    COTTAGE: 'cottage',
    CASTLE: 'castle',
    ESTATE: 'estate',
    VILLA: 'villa',
}
